// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3t4he","index":"styles_index__18uKH"};